module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/menu-item-container/menu-item-container.component.html
// module id = 738
// module chunks = 0